import { z } from 'zod';

import { createEntityAdapterSchema, findDuplicateIds } from '../../base';
import { PronunciationSchema } from './pronunciations.schema';

export const PronunciationsSchema = z
  .object({
    pronunciations: createEntityAdapterSchema(PronunciationSchema),
  })
  .superRefine((data, ctx) => {
    const pronunciations = Object.values(data.pronunciations.entities);
    const duplicateIds = findDuplicateIds(pronunciations);
    for (const duplicate of duplicateIds) {
      ctx.addIssue({
        path: ['pronunciations', 'entities', duplicate.id, 'id'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate ID',
      });
    }
  });

export type Pronunciations = z.infer<typeof PronunciationsSchema>;
